{
  "en": {
    "published": {
      "labels": {
        "notPublished": "Not published",
        "publishedCustomer": "Published for customers",
        "publishedCustomerPartners": "Published for customers & partners",
        "publishedPartners": "Published for partners"
      },
      "publish_mode": {
        "inherit": "Follow template",
        "inherit_info": "Keep each item's published or unpublished state from the template",
        "publish": "Publish to customers",
        "publish_info": "Customers can see these right away",
        "title": "Publishing",
        "unpublished": "Create without publishing",
        "unpublished_info": "Hidden from customers until you publish them"
      }
    }
  }
}
